import { PublicClientApplication } from '@azure/msal-browser';

/** Entra ID SPA 应用注册：AI Security Hub SPA */
export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: 'c2cf771b-97a0-4a00-bbc3-51f8be4e2891',
    authority: 'https://login.microsoftonline.com/9aea4c40-8df1-4be5-b8bc-0d6f3830a650',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
});

export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};
